export default [
	{
		path: 'acciones-movimientos/listado-plazas/:id_tipo_contratacion',
		name: 'acciones-movimientos-listado-plazas',
		component: () => import('@/views/acciones-movimientos/listado_plazas/views/DetallePlazas.vue'),
	},
	{
		path: 'acciones-movimientos/listado-plazas',
		name: 'acciones-movimientos-listado-estructura-plazas',
		component: () => import('@/views/acciones-movimientos/listado_plazas/views/EstructuraPlazas.vue'),
	},
];
